var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#99A3AC",
    d: "m15 5.833-3 1.945a1.91 1.91 0 0 0-.703-1.47C12.313 5.714 13 4.64 13 3.404 13 1.523 11.433 0 9.5 0S6 1.523 6 3.403a3.34 3.34 0 0 0 1.056 2.43H5.22A2.85 2.85 0 0 0 6 3.89C6 2.278 4.657.972 3 .972S0 2.278 0 3.89c0 .879.408 1.658 1.041 2.192C.424 6.412 0 7.044 0 7.778v3.889c0 1.073.896 1.944 2 1.944h8c1.104 0 2-.87 2-1.944l3 1.944c.552 0 1-.435 1-.972V6.806a.987.987 0 0 0-1-.973m-12 0c-1.104 0-2-.87-2-1.944s.896-1.945 2-1.945 2 .871 2 1.945-.896 1.944-2 1.944m6.5.006c-1.384 0-2.505-1.091-2.505-2.436C6.995 2.057 8.117.967 9.5.967s2.505 1.09 2.505 2.436S10.884 5.839 9.5 5.839"
  })));
};
export default SvgVideo;